export default function Footer(props) {
  const fetchSettings = props.data.settings;

  return (
    <footer>
      <div className="footer-inner">
        <a href={fetchSettings.url} target="_blank" rel="noopener noreferrer">
          {`Return to ${fetchSettings.return}`}
        </a>
      </div>
    </footer>
  );
}
